import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { TOGGLE_AUDIT_STATUS_WARNING_POPUP } from "./reducers/audit-properties-reducer";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import { COMPLETED_SATUS } from "./constants";
import { SET_USER_TASK_GRID_FILTER } from "./reducers/external-audit-reducer";

export const toggleStatusChangeeWarningPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_AUDIT_STATUS_WARNING_POPUP,
    data: {
      isStatusChangeWarningPopupVisible: isVisible
    },
  });
}

const taskItem = item => {
  return <li key={item.userTaskId}>{item.refTaskName}</li>
}

const StatusChangeWarningPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const inCompleteTaskList = useSelector(
    (state) => state["userTaskListReducer"].userTaskList?.filter(x => x.status.toUpperCase() !== COMPLETED_SATUS && x.requiredForAuditCompletionInd),
    isEqual
  );

  const isStatusChangeWarningPopupVisible = useSelector(
    (state) => state["auditPropertiesReducer"].isStatusChangeWarningPopupVisible,
    isEqual
  );

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          toggleStatusChangeeWarningPopup(false, dispatch);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={400}
        height={'auto' }
        className="-warning-popup"
        visible={isStatusChangeWarningPopupVisible}
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_AUDIT_STATUS_WARNING_POPUP,
            reducerName: "auditPropertiesReducer",
            widgetOptionBindings: {
              visible: "isStatusChangeWarningPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div className="message-section">
                  The following required tasks must be completed before the audit can be put into the Completed :
                  {
                    inCompleteTaskList?.map(taskItem)
                  }
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    toggleStatusChangeeWarningPopup(false, dispatch);
                    props.onChangeStatusWarningOkClick();
                  }}
                >
                  Ok
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default StatusChangeWarningPopup;